import { Component, Input, OnInit } from '@angular/core';
import { Shelf } from '@app-model/shelf'; 

@Component({
  selector: 'app-shelf-banner-item',
  templateUrl: './shelf-banner-item.component.html',
  styleUrls: ['./shelf-banner-item.component.scss']
})
export class ShelfBannerItemComponent implements OnInit {

  @Input() shelf: Shelf;
  constructor() { }

  ngOnInit(): void {
  }
  
  redirect(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
